
<template>
    <div>
        <b-tabs pills card vertical class="">
            <b-tab title-link-class="" :key="idx"  :active="group.is_active"  v-for="(group,idx) in params">
                <template slot="title">
                    <div class="fs-lg px-4 text-center ">
                        {{group.title }}
                    </div>
                </template>

                <b-card-text>
                    <component
                        v-bind:is="group.component"
                        :items="group.items"
                        :cur_idx="idx"
                        @change_extra="set_on_change"
                    >
                    </component>
                </b-card-text>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import product_ingredients from "../extra_components/product_ingredients.vue";
import product_allergens from "../extra_components/product_allergens.vue";
import product_labels from "../extra_components/product_labels.vue";
import product_additives from "../extra_components/product_additives.vue";
import product_nutrition from "../extra_components/product_nutrition.vue";
import product_producer_information from "../extra_components/product_producer_information.vue";
import product_distributor_information from "../extra_components/product_distributor_information.vue";
import product_country_of_origin from "../extra_components/product_country_of_origin.vue";
import product_conditions_of_use_and_storage from "../extra_components/product_conditions_of_use_and_storage.vue";
import product_regulatory_information from "../extra_components/product_regulatory_information.vue";

export default {
    name: "product_advanced",

    components : {
        product_ingredients,
        product_allergens,
        product_labels,
        product_additives,
        product_nutrition,
        product_producer_information,
        product_distributor_information,
        product_country_of_origin,
        product_conditions_of_use_and_storage,
        product_regulatory_information
    },

    props : {
        product : {
            type : Object
        }
    },


    created () {
        this.load_params();
    },

    data() {
        return {
            is_load: true,
            params : [],
        }
    },

    methods :  {

        async load_params () {
            this.is_load = true;
            this.params = [];
            await api.get('/internal/v1/catalog/products/'+ this.product.id +'/extra').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.set_params(data.data);
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.set_params([]);
             //   EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        set_on_change(items,type) {
            console.log('update_items',type,items);
            this.params.map(function(group) {
                if(group.type == type) {
                    group.items = [];
                    items.map(function(option) {
                        group.items.push(option);
                    });
                }
            });

            this.$emit('on_change','extra',this.params)
        },

        set_params(data) {

            let self = this;
            data.map(item => {
                item.is_active = false;
                item.title = self.__t('EXTRA_' + item.type.toUpperCase());
                item.component = 'product_' + item.type;
                self.params.push(item);
            });

            this.$emit('on_change','extra',this.params)
        }
    }
}
</script>



<style scoped>

</style>
